import React,{useEffect} from "react";
import { analytics } from "../firebaseConfig";
import { logEvent } from "firebase/analytics";
const Cancel = () => {
  useEffect(()=>{
    logEvent(analytics, 'cancel_subscription_page');
  },[])
  return(
  <div className="text-center p-10">
    <h2 className="text-2xl font-semibold text-red-600">Subscription Canceled</h2>
    <p className="mt-4">Your subscription was not completed. Try again anytime.</p>
  </div>
)};

export default Cancel;
